define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var FilterMultiSelectListViewController = require('web-agent-components/FilterMultiSelectListViewController');

    var SearchInputViewController = ViewController.extend({
        ControllerName: "SearchInputViewController",

        animationDuration: 100,

        LPViewMap: {
            searchInput: ".lpview_search_input",
            searchInputContainer: ".lpview_search_input_container",
            clearSearchIcon: ".lpview_clear_search_icon",
            searchIcon: ".lpview_search_icon",
            filterIcon: ".lpview_filter_icon",
            filterWindow: ".lpview_filterWindow",
            filterContainer: ".lpview_search_input_container"
        },

        LPClassesMap: {
            SearchCaption: "search_caption",
            focus: "focused"
        },

        initialize: function (constructorData) {
            this.inputBlurredWidth = constructorData.inputBlurredWidth;
            this.inputFocusedWidth = constructorData.inputFocusedWidth;
            this.keyUpCallback = constructorData.keyUpCallback;
            this.valueChangeCallback = constructorData.valueChangeCallback;
            this.blurCallback = constructorData.blurCallback;
            this.focusCallback = constructorData.focusCallback;
            this.preClearSearchCallback = constructorData.preClearSearchCallback;
            this.clearSearchCallback = constructorData.clearSearchCallback;
            this.searchIconCallback = constructorData.searchIconCallback;
            this.selectTextOnFocuse = constructorData.selectTextOnFocuse;
            this.context = constructorData.context;
            this.filterIconCallback = constructorData.filterIconCallback;
            this.filterOptions = constructorData.filterOptions;
            this.disabledOption = constructorData.disabledOption;
            this.tableName = constructorData.tableName;
            this.searchFilterEventCallback = constructorData.searchFilterEventCallback;
            this.alphaOption = constructorData.alphaOption;
            this.filterDefaultSelection = constructorData.filterDefaultSelection;
            this.setUpTemplateAndCreateView();

            this.searchInput = this.getFirstElement(this.LPViewMap.searchInput);
            this.searchInputContainer = this.getFirstElement(this.LPViewMap.searchInputContainer);
            this.searchInput.value = constructorData.defaultText || "";

            this.lastChangeValue = this.searchInput.value;

            if (this.filterOptions) {
                this.filterView = new FilterMultiSelectListViewController({
                    searchFilterEventCallback: this.searchFilterEventCallback,
                    className: "filter_multi_select_view",
                    title: "",
                    afterTitle: (constructorData.afterTitle === "") ? "" : this.translate("filter_after_title_separator"),
                    filterName: "historyDataFilter",
                    filterIdPrefix: constructorData.filterIdPrefix,
                    filterDataModelClass: this.filterOptions.filterItems,
                    items: this.filterOptions.filterItems,
                    iconCallback: this.filterIconCallback,
                    iconContext: constructorData.context,
                    defaultFilter: {
                        selectedItems: this.filterOptions.filterDefaultSelection
                    },
                    hidden: true,
                    iconId: constructorData.iconId,
                    disabledOption: this.disabledOption,
                    tableName: this.tableName,
                    alphaOption: this.alphaOption
                });
                this.addViewController({viewController: this.filterView, target: this.LPViewMap.filterContainer, hidden: true});
            }

            if (this.searchInput.value === "") {
                this.searchInputContainer.style.width = this.inputBlurredWidth;
            } else {
                this.searchInputContainer.style.width = this.inputFocusedWidth;
            }
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.searchInput, DOMEvent: 'keyup', callback: this.handleKeyUp});
            //this.bindViewEvent({selector: this.LPViewMap.searchInput, DOMEvent: 'blur', callback: this.onInputBlurred});
            this.bindViewEvent({selector: this.LPViewMap.searchInput, DOMEvent: 'focus', callback: this.onInputFocus});
            this.bindViewEvent({selector: this.LPViewMap.searchIcon, DOMEvent: 'click', callback: this.onSearchIconClicked});
            //this.bindViewEvent({selector: this.LPViewMap.searchInputContainer, DOMEvent: 'blur', callback: this.onInputBlurred});
            this.bindViewEvent({selector: this.LPViewMap.searchInputContainer, DOMEvent: 'mouseover', callback: this.onMouseOverSearchInputContainer});
            this.bindViewEvent({selector: this.LPViewMap.searchInputContainer, DOMEvent: 'mouseleave', callback: this.onMouseLeaveSearchInputContainer});

            if (this.filterOptions) {
                this.bindViewEvent({selector: this.LPViewMap.filterIcon, DOMEvent: 'click', callback: this.openFilterMultiSelect});
            } else {
                this.bindViewEvent({selector: this.LPViewMap.clearSearchIcon, DOMEvent: 'click', callback: this.onClearSearchClicked});
            }

            // Adding Change listeners.
            // Internet Explorer Property change.
            this.bindViewEvent({selector: this.LPViewMap.searchInput, callback : this.emitValueChangeEvent, DOMEvent : "propertychange"});

            // Common browser Property Changes.
            this.bindViewEvent({selector: this.LPViewMap.searchInput, callback : this.emitValueChangeEvent, DOMEvent : "input"});

            // Data-Object Manipulations changes.
            this.bindViewEvent({selector: this.LPViewMap.searchInput, callback : this.emitValueChangeEvent, DOMEvent : "paste"});
            this.bindViewEvent({selector: this.LPViewMap.searchInput, callback : this.emitValueChangeEvent, DOMEvent : "cut"});
            this.bindViewEvent({selector: this.LPViewMap.searchInput, callback : this.emitValueChangeEvent, DOMEvent : "dragend"});
            this.bindViewEvent({selector: this.LPViewMap.searchInput, callback : this.emitValueChangeEvent, DOMEvent : "drop"});
        },

        render: function () {
        }
    });
    /**
     * this function is used to initiate the search window on refresh
     * @param searchArea - the UI state to initiate the search window - which checkbox to check
     * if searchArea is null - it will initiate with the default value (transcript mode)
     */
    SearchInputViewController.prototype.setFilter = function (searchArea) {
        if (searchArea) {
            this.filterView.filterData.selectedItems = searchArea;
            this.filterView.filterUIData.selectedItems = searchArea;
        }
    };

    /**
     * check for value change and send 'Change' event if has changes.
     */
    SearchInputViewController.prototype.emitValueChangeEvent = function () {
        var newValue = this.getText();
        var oldValue = this.lastChangeValue;
        if (newValue !== oldValue) {
            this.lastChangeValue = newValue;
            if (this.valueChangeCallback) {
                this.valueChangeCallback.call(this.context, {
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        }
    };

    SearchInputViewController.prototype.setUpTemplateAndCreateView = function () {
        var tableTemplate;
        if (this.filterOptions) {
            tableTemplate = "LP_search_input_with_filter.html";
        } else {
            tableTemplate = "LP_search_input.html";
        }
        this.createView({templateFile: tableTemplate});
    };

    SearchInputViewController.prototype.handleKeyUp = function (e) {
        if (this.keyUpCallback) {
            this.keyUpCallback.call(this.context, e);
        }
        this.emitValueChangeEvent();
    };

    SearchInputViewController.prototype.onMouseOverSearchInputContainer = function () {
        this.unbindViewEvent({selector: this.LPViewMap.searchInput, DOMEvent: 'blur', callback: this.onInputBlurred});
    };

    SearchInputViewController.prototype.onMouseLeaveSearchInputContainer = function () {
        this.bindViewEvent({selector: this.LPViewMap.searchInput, DOMEvent: 'blur', callback: this.onInputBlurred});
    };

    SearchInputViewController.prototype.onClearSearchClicked = function () {
        if (this.preClearSearchCallback) {
            this.preClearSearchCallback.call(this.context);
        }
        var oldValue = this.searchInput.value;
        this.searchInput.value = "";
        this.emitValueChangeEvent();
        var that = this;
        setTimeout(function () {
            that.searchInput.focus();
        }, 350);
        if (this.clearSearchCallback) {
            this.clearSearchCallback.call(this.context, {oldValue: oldValue});
        }
    };

    SearchInputViewController.prototype.onSearchIconClicked = function () {
        if (this.searchIconCallback) {
            this.searchIconCallback.call(this.context);
        }
    };

    SearchInputViewController.prototype.onInputFocus = function () {
        this.addClass(this.searchInputContainer, this.LPClassesMap.focus);
        // Set width animation only if needed
        if (this.searchInput.value === "" && this.inputBlurredWidth != this.inputFocusedWidth) {
            this.animate(this.searchInputContainer, {duration: this.animationDuration, width: this.inputFocusedWidth});
        }
        // if ask to select the text on focus, set a timer do to browsers bug
        if (this.selectTextOnFocuse) {
            var that = this;
            setTimeout(function () {
                that.searchInput.select();
            }, 50);
        }
        if (this.focusCallback) {
            this.focusCallback.call(this.context);
        }
        this.closeFilterMultiSelect();
    };

    SearchInputViewController.prototype.onInputBlurred = function () {
        this.removeClass(this.searchInputContainer, this.LPClassesMap.focus);
        var that = this;
        // Set width animation only if needed
        if (this.searchInput.value === "" && this.inputBlurredWidth != this.inputFocusedWidth) {
            this.animate(this.searchInputContainer, {duration: this.animationDuration, width: this.inputBlurredWidth});
        }
        if (that.blurCallback) {
            that.blurCallback.call(that.context);
        }
        //this.closeFilterMultiSelect();
    };

    SearchInputViewController.prototype.getText = function () {
        return this.searchInput.value;
    };

    SearchInputViewController.prototype.setText = function (value) {
        this.searchInput.value = value;
        if (typeof(value) !== "undefined" && value !== "") {
            this.searchInputContainer.style.width = this.inputFocusedWidth;
        }
        this.emitValueChangeEvent();
    };

    SearchInputViewController.prototype.isFocused = function () {
        return this.hasSingleClass(this.searchInputContainer, this.LPClassesMap.focus);
    };

    SearchInputViewController.prototype.disableActions = function () {
        if (this.filterView) {
            //return this.filterIcon.setAttribute("disabled", "disabled"); TODO
        }
        return this.searchInput.setAttribute("disabled", "disabled");
    };

    SearchInputViewController.prototype.enableActions = function () {
        if (this.filterView) {
            //return this.filterIcon.removeAttribute("disabled"); TODO
        }
        return this.searchInput.removeAttribute("disabled");
    };

    SearchInputViewController.prototype.lpFocus = function () {
        this.searchInput.focus();
    };

    SearchInputViewController.prototype.isChatIdQuery = function () {
        return (this.getSelectedItems().indexOf(this.alphaOption) >= 0);
    };
    SearchInputViewController.prototype.getSelectedItems = function () {
        if (this.filterView && this.filterView.filterUIData && this.filterView.filterUIData.selectedItems) {
            return this.filterView.filterUIData.selectedItems;
        }
        return this.filterDefaultSelection;
    };
    SearchInputViewController.prototype.getTextValue = function () {
        return this.searchInput.value;
    };
    SearchInputViewController.prototype.openFilterMultiSelect = function () {
        this.filterView.lpShow();
    };
    SearchInputViewController.prototype.closeFilterMultiSelect = function () {
        if (this.filterView) {
            this.filterView.lpHide();
        }
    };

    return SearchInputViewController;

});
